import { render, staticRenderFns } from "./SimpleElement.vue?vue&type=template&id=1eaf4486&scoped=true&"
import script from "./SimpleElement.vue?vue&type=script&lang=js&"
export * from "./SimpleElement.vue?vue&type=script&lang=js&"
import style0 from "./SimpleElement.vue?vue&type=style&index=0&id=1eaf4486&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaf4486",
  null
  
)

export default component.exports